export enum PromoTypeEnum {
  MONEY = 'money',
  PERCENT = 'percent',
}
